import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ce3fdf4c&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ce3fdf4c&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce3fdf4c')) {
      api.createRecord('ce3fdf4c', component.options)
    } else {
      api.reload('ce3fdf4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ce3fdf4c&lang=pug", function () {
      api.rerender('ce3fdf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/account/detail/skeleton/index.vue"
export default component.exports